import { render } from "./CarritoView.vue?vue&type=template&id=383403ae&scoped=true"
import script from "./CarritoView.vue?vue&type=script&lang=js"
export * from "./CarritoView.vue?vue&type=script&lang=js"

import "./CarritoView.vue?vue&type=style&index=0&id=383403ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383403ae"]])

export default __exports__